var _defs, _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #001213;\n        stroke-miterlimit: 10;\n        stroke-width: 7px;\n      }\n\n      .st1 {\n        fill: #f1f1f2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 78,
    cy: 78,
    r: 77
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "47.9 56.6 108.1 56.6 84.4 85.6 84.4 106.6 71.8 113.4 71.8 85.6 47.9 56.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFilter);
export default __webpack_public_path__ + "static/media/button_filter.08c84c355917bd9ab8120ea9e2088926.svg";
export { ForwardRef as ReactComponent };